import env from "../../utils/env";

const AppContextService = function (HttpService, AuthService) {
  "ngInject"

  let _appContext;
  let _activeLocation = 'au';

  const getAppContext = () => {
   return _appContext;
  }

  const setAppContext = (response) => {
    _appContext = response;
    return _appContext;
  }

  const clearAppContext = () => {
    _appContext = undefined;
    return _appContext;
  }

  const getActiveLocation = () => {
    return _activeLocation;
  }

  const setActiveLocation = (newLocation) => {
    _activeLocation = newLocation;
    return _activeLocation;
  }

  const fetchAppContext = (successCallback, errorCallback) => {
    HttpService.get("identity/userinfo", successCallback, errorCallback)
  }

  const hasAccess = (roles) => {
    return roles && (roles.indexOf("GlobalAdmin") != -1 || roles.indexOf("Admin") != -1 || roles.indexOf("ReadOnlyAdmin") != -1 || roles.indexOf("Analytics") != -1)
  }

  const hasReadAccess = (roles) => {
    return roles && roles.indexOf("ReadOnlyAdmin") != -1;
  }

  const hasGlobalAdminAccess = (roles) => {
    return roles && (roles.indexOf("GlobalAdmin") != -1);
  }

  const hasPaymentsAdminAccess = (roles) => {
    return roles && (roles.indexOf("Payments") != -1);
  }

  const hasLoginAsUserAccess = (roles) => {
    return roles && (roles.indexOf("LogInAsUser") != -1);
  }

  const isAdmin = () => {
    var location = window.location.hostname.toLowerCase();
    return env.isAdmin(location);
  }

  const isAnalytics = () => {
    var location = window.location.hostname.toLowerCase();
    return env.isAnalytics(location);
  }

  return { getAppContext, fetchAppContext, setAppContext, clearAppContext, hasAccess, hasReadAccess, hasGlobalAdminAccess, hasPaymentsAdminAccess, hasLoginAsUserAccess, isAnalytics, isAdmin, getActiveLocation, setActiveLocation }
};

export default AppContextService;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/services/app-context.service.js
 **/